import SeasonalCalendar from "../model/SeasonalCalendar";

const SeasonalCalendarRepository = {
  MonthDict: [
    { name: "Janeiro", checked: false, disable: false, id: 0 },
    { name: "Fevereiro", checked: false, disable: false, id: 1 },
    { name: "Março", checked: false, disable: false, id: 2 },
    { name: "Abril", checked: false, disable: false, id: 3 },
    { name: "Maio", checked: false, disable: false, id: 4 },
    { name: "Junho", checked: false, disable: false, id: 5 },
    { name: "Julho", checked: false, disable: false, id: 6 },
    { name: "Agosto", checked: false, disable: false, id: 7 },
    { name: "Setembro", checked: false, disable: false, id: 8 },
    { name: "Outubro", checked: false, disable: false, id: 9 },
    { name: "Novembro", checked: false, disable: false, id: 10 },
    { name: "Dezembro", checked: false, disable: false, id: 11 }
  ],
  WeekDay: [
    { name: "Domingo", checked: false, disable: false, id: 0 },
    { name: "Segunda-Feira", checked: false, disable: false, id: 1 },
    { name: "Terça-Feira", checked: false, disable: false, id: 2 },
    { name: "Quarta-Feira", checked: false, disable: false, id: 3 },
    { name: "Quinta-Feira", checked: false, disable: false, id: 4 },
    { name: "Sexta-Feira", checked: false, disable: false, id: 5 },
    { name: "Sábado", checked: false, disable: false, id: 6 }
  ],
  updated: false,
  fullLoading:false,
  indicatorsRelated:[],
  indicatorsRelatedIDS:[],
  allCalendars:[],
  Save(calendar = SeasonalCalendar) {
    sessionStorage.SeasonalCalendar = JSON.stringify(calendar)
  },

  Get() {
    let seasonalCalendar = sessionStorage.SeasonalCalendar
    if (!seasonalCalendar) return new SeasonalCalendar();

    return JSON.parse(seasonalCalendar)
  },

  CanUpdate() {
    return this.updated
  },

  Remove() {
    if (this.updated) return false
    sessionStorage.removeItem("SeasonalCalendar")
    return true;
  },

  GenerateBaseCalendar() {
    let sheets = [];
    let currentYear = new Date().getFullYear();

    for (let month = 0; month <= 11; month++) {
      let sheetInfo = {
        name: `${this.MonthDict[month].name}`,
        data: []
      }

      let totalDaysInMonth = new Date(currentYear, month + 1, 0).getDate();
      for (let day = 1; day <= totalDaysInMonth; day++) {
        let dateObj = new Date(currentYear, month, day);
        let sheetData = {
          "Dia": `${("0" + dateObj.getDate()).slice(-2)}/${("0" + (dateObj.getMonth() + 1)).slice(-2)}/${dateObj.getFullYear()}`,
          "Dia da Semana": `${this.WeekDay[dateObj.getDay()].name}`,
          "Calendário Base": ""
        }

        sheetInfo.data.push(sheetData);
      }

      sheets.push(sheetInfo)
    }

    return sheets;
  },

  FormatDateLocales(dates, monthName) {
    let monthFound = this.MonthDict.filter(m => m.name.toLowerCase().trim() == monthName.toLowerCase().trim());
    let monthFormat = "01";
    if (monthFound.length > 0) monthFormat = `0${monthFound[0].id + 1}`.slice(-2);

    const currentYear = new Date().getFullYear().toString();

    let positions = {
      pos1: [],
      pos2: [],
      pos3: [],
    }

    dates.map(item => {
      let format = null;
      if (item.Dia.includes("-")) format = item.Dia.split("-");
      else if (item.Dia.includes("/")) format = item.Dia.split("/");
      else if (item.Dia.includes(".")) format = item.Dia.split(".");

      if (format != null) {
        if (format[0] && !positions.pos1.includes(format[0])) positions.pos1.push(format[0])
        if (format[1] && !positions.pos2.includes(format[1])) positions.pos2.push(format[1])
        if (format[2] && !positions.pos3.includes(format[2])) positions.pos3.push(format[2])
      } else {
        format = item.Dia
      }

      return format;
    })

    let posArr = [positions.pos1, positions.pos2, positions.pos3]
    const max = Math.max(positions.pos1.length, positions.pos2.length, positions.pos3.length)
    let dayPostion = posArr.findIndex(item => item.length == max);

    return dates.map(item => {
      let splitted = null
      let dateDay = null

      if (item.Dia.includes("-")) splitted = item.Dia.split("-");
      else if (item.Dia.includes("/")) splitted = item.Dia.split("/");
      else if (item.Dia.includes(".")) splitted = item.Dia.split(".");

      if (splitted != null) dateDay = `0${splitted[dayPostion]}`.slice(-2)

      return {
        ...item,
        Dia: dateDay != null ? `${currentYear}-${monthFormat}-${dateDay}` : item.Dia
      }
    })
  },

  FormatNumber(str) {
    if(str == undefined) return null;
    let cleaned = str.replace(/[,\.](?=\d{3}(,|\.|$))/g, '');
    cleaned = cleaned.replace(',', '.');
    const number = parseFloat(cleaned);
    return isNaN(number) ? null : number;
  },

  FormatCalendarExcel(jsonData, monthsToImport) {
    const importRequest = {
      ImportedExcelCalendars: []
    };

    //obter os nomes dos calendarios

    //para cada calendário, preencher os valores dos dias só se já não existir
    let calendarsNames = []

    for(let data of jsonData){
      if (!monthsToImport.includes(data.sheetName)) continue;
      data.data.forEach(dayVal => {
        let names = Object.keys(dayVal).filter(d => !["Dia", "Dia da Semana"].includes(d) && !calendarsNames.includes(d));

        calendarsNames.push(...names);
      })
    }

    calendarsNames.forEach(calendarName => {
      const importedCalendar = {
        CalendarName: calendarName,
        CalendarToImport: {
          Year: new Date().getFullYear().toString(),
          Measurement: "",
          Months: []
        }
      };

      for (let month of jsonData) {
        if (!monthsToImport.includes(month.sheetName)) continue;

        let monthDataDays = [];

        let today = new Date().setDate(new Date().getDate() - 1);

        month.data.forEach(day => {
          let numeroFormatado = this.FormatNumber(day[calendarName]);
          let splittedDay = day["Dia"].split("-");
          let convertedDay = new Date(splittedDay[0], Number(splittedDay[1]) - 1, splittedDay[2]);

          let existed = monthDataDays.filter(md => md.DateTime == `${splittedDay[0]}-${splittedDay[1]}-${splittedDay[2]}`)

          if (numeroFormatado != null && convertedDay >= today && (existed == undefined || existed.length == 0)) {
            monthDataDays.push({
              DateTime: `${splittedDay[0]}-${splittedDay[1]}-${splittedDay[2]}`,
              DateWeek: day["Dia da Semana"].toString(),
              DateValue: numeroFormatado.toString()
            })
          }
        })

        const seasonalMonth = {
          MonthName: month.sheetName.toString(),
          SeasonalDays: monthDataDays
        };

        importedCalendar.CalendarToImport.Months.push(seasonalMonth);
      }

      importRequest.ImportedExcelCalendars.push(importedCalendar);
    });

    return importRequest;
  },

  GenerateFullCalendar(dataToFill) {
    let currentYear = new Date().getFullYear();
    let calendarOBJ = {
      Year:currentYear,
      Measurement: dataToFill && dataToFill.Measurement ? dataToFill.Measurement : "",
      Months:[]
    }
    let calendar = [];
    for (let month = 0; month <= 11; month++) {
      let monthInfo = {
        MonthName: `${this.MonthDict[month].name}`,
        SeasonalDays: []
      }

      let totalDaysInMonth = new Date(currentYear, month + 1, 0).getDate();
      let monthFound = null;

      if(dataToFill != undefined && dataToFill.Months && dataToFill.Months.length > 0){
        let m = dataToFill.Months.filter(item => {
          return item.MonthName == monthInfo.MonthName
        })
        if(m.length > 0){
          monthFound = m[0]
        }
      }

      for (let day = 1; day <= totalDaysInMonth; day++) {
        let dateObj = new Date(currentYear, month, day);
        let dateFormatBar = `${("0" + dateObj.getDate()).slice(-2)}/${("0" + (dateObj.getMonth() + 1)).slice(-2)}/${dateObj.getFullYear()}`
        let dateFormatDash = `${dateObj.getFullYear()}-${("0" + (dateObj.getMonth() + 1)).slice(-2)}-${("0" + dateObj.getDate()).slice(-2)}`
        let dateValue = null;
        if(monthFound != null && monthFound.SeasonalDays && monthFound.SeasonalDays.length > 0){
          let d = monthFound.SeasonalDays.filter(item => item.DateTime == dateFormatDash || item.DateTime == dateFormatBar);

          if(d.length > 0){
            dateValue = d[0].DateValue;
          }
        }

        let monthData = {
          DateTime: dateFormatDash,
          DateWeek: `${this.WeekDay[dateObj.getDay()].name}`,
          DateValue: dateValue != null ? dateValue : "0"
        }

        monthInfo.SeasonalDays.push(monthData);
      }

      calendar.push(monthInfo)
    }

    calendarOBJ.Months = calendar;

    return calendarOBJ;
  },
}

export default SeasonalCalendarRepository